import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons'
import {
  FieldReadable,
  GroupReadable,
  ReportFilterReadable,
  ValuesReadable
} from '@crm/api'
import { DndTable } from '@crm/components'
import { Button, Space } from 'antd'

import { useMemo } from 'react'

import type { TableColumnsType } from 'antd'

type FieldType =
  | FieldReadable
  | ReportFilterReadable
  | GroupReadable
  | ValuesReadable

type Props = {
  title: string
  fields: FieldType[]
  onRemove: (index: number) => void
  onAdd: () => void
  onEdit: (index: number) => void
  renderItem?: (field: FieldType, i: number) => React.ReactNode
  onSortEnd?: (action: (state: FieldType[]) => FieldType[]) => void
}

export const FieldsCard = ({
  title,
  fields,
  onRemove,
  onAdd,
  onEdit,
  onSortEnd,
  renderItem
}: Props) => {
  const renderItemFunc = renderItem || ((field) => field?.label)

  const columns: TableColumnsType<FieldReadable> = useMemo(
    () => [
      {
        render: (field, _, index) => renderItemFunc(field, index)
      },
      {
        width: 50,
        render: (_, __, index) => (
          <Space>
            <Button
              icon={<EditOutlined />}
              type="primary"
              onClick={() => onEdit(index)}
            />
            <Button icon={<DeleteOutlined />} onClick={() => onRemove(index)} />
          </Space>
        )
      }
    ],
    []
  )

  return (
    <DndTable
      onDragEnd={onSortEnd}
      items={fields.map(({ id }) => id || 0)}
      title={() => (
        <Space>
          {title}
          <Button
            icon={<PlusOutlined />}
            type="primary"
            size="small"
            onClick={onAdd}
          />
        </Space>
      )}
      columns={columns}
      dataSource={fields}
      showHeader={false}
      scroll={{ x: 300 }}
      rowKey="id"
      pagination={false}
      showSorterTooltip={false}
    />
  )
}
